import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import { Modal, Form, Row, Col, Input, Button, Spin } from 'antd'
import { ExclamationCircleFilled} from '@ant-design/icons'
import {withTranslation} from 'react-i18next'
const {TextArea} = Input

@inject('emailAddressStore')
@observer
class FormModal extends Component {
  state = {
  }
  formRef = React.createRef()
  componentDidMount() {
  }
  handleOk = () => {
    const {emailAddressStore, handleCancel, record} = this.props
    const {searchItem} = emailAddressStore
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        "id": record?.id,
        "marketGroupId": searchItem?.marketGroupId,
        "addressText": fieldsValue?.addressText,
      }
      emailAddressStore.onAddAddressAction({...params}).then(res=> {
        if (res?.data?.code === 0) {
          handleCancel()
        }
      })
    }).catch(() => {})
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }
  render() {
    const { emailAddressStore, addModalVisible, handleCancel, t } = this.props
    const { searchItem, groupList, isFetchingAdd } = emailAddressStore
    return (
      <>
        <Modal
          title={`${t('emailSend.addAddressTit')}-${groupList?.find(a=>a?.id===searchItem?.marketGroupId)?.groupName}`}
          closable={true}
          visible={addModalVisible}
          onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          width={'50%'}
          centered
          footer={[
            <Button key="Save" type="primary" onClick={this.handleOk} >{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={handleCancel}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Spin spinning={isFetchingAdd}>
            <Form ref={this.formRef} key="addMapping" layout="vertical">
              <Row gutter={[10, 10]}>
                <Col span={24}>
                  <div>数据格式说明:</div>
                  <div className='code_txt'>
                    user1@domain.com; 姓名1; 性别; 生日; 手机; 地区; 变量1; 变量2 <br />
                    user2@domain.com; 姓名2; 性别; 生日; 手机; 地区; 变量1; 变量2; 变量3; 变量4; 变量5; <br />
                    user3@domain.com; 姓名3; 性别; 生日; 手机; 地区; 变量1
                  </div>
                </Col>
                <Col span={24}>
                  <div className='tips_box'>
                    <div><ExclamationCircleFilled /> 一个地址占一行，格式如上，之间用分号“；”隔开。</div>
                    <div>姓名, 性别, 生日, 手机, 地区, 变量1至10, 每个变量支持最长100个字符。</div>
                    <div>在线上传最多只支持上传1000个地址，大于1000不予上传，请文件导入上传。</div>
                  </div>
                </Col>
                <Col span={24}>
                  <Form.Item name="addressText" rules={[{ required: true, message: `${t(`general.pleaseEnter`)}`}]}>
                    <TextArea rows={10} placeholder={t(`general.pleaseEnter`)} style={{width: '100%'}} />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Spin>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
